import { Component, Input } from '@angular/core';

import {
  CommonFeatureCardConfig,
  CommonFeatureCardVariant,
} from './common-feature-card.interface';

@Component({
  selector: 'app-common-feature-card',
  templateUrl: './common-feature-card.component.html',
  styleUrls: ['./common-feature-card.component.scss'],
})
export class CommonFeatureCardComponent {
  @Input() variant: CommonFeatureCardVariant = 'home';
  @Input() config!: CommonFeatureCardConfig;
  @Input() ariaLabel?: string;
}
